import { useFormik } from 'formik'
import { useSnackbar } from 'notistack'

import { ConsoleDialog } from '@/components/ConsoleDialog'
import { FormikTextField } from '@/components/inputs/FormikTextField'
import { LowLatencyHostInfo } from '@/components/LowLatencyHosts/types'
import { ApiError } from '@/service/ApiError'
import { streamingRestApi } from '@/service/streamingApi'
import { FormDialogProps } from '@/types/forms'
import { formikSaveButtonProps } from '@/utils/forms'

import { addLowLatencyHostsFormValidationSchema } from './addLowLatencyHostsForm.validation'

const LowLatencyHostsForm = ({
  onClose,
  onSubmit,
  open = false
}: FormDialogProps<LowLatencyHostInfo>) => {
  const { enqueueSnackbar } = useSnackbar()

  const formik = useFormik({
    initialValues: {
      displayName: '',
      host: ''
    },
    validationSchema: addLowLatencyHostsFormValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      if (!values.displayName || !values.host) return

      try {
        setSubmitting(true)
        await streamingRestApi.endpoints.lowLatencyHosts.addLowLatencyHost({
          displayName: values.displayName,
          host: values.host
        })

        onSubmit?.()
        enqueueSnackbar(`Successfully added Host: ${values.displayName}`, { variant: 'success' })
        setSubmitting(false)
        handleClose()
      } catch (e) {
        const errorMessage = [`Failed to add Host: ${e as unknown as ApiError}`]
          .filter(Boolean)
          .join(':')
        enqueueSnackbar(errorMessage, { variant: 'error' })
        setSubmitting(false)
        throw errorMessage
      }
    }
  })

  const handleClose = () => {
    onClose?.()
    formik.resetForm()
  }

  return (
    <ConsoleDialog
      open={open}
      title="Add Host"
      onClose={handleClose}
      SaveButtonProps={formikSaveButtonProps(formik)}
    >
      <FormikTextField
        label="Name"
        placeholder="Name"
        required
        name="displayName"
        formik={formik}
      />
      <FormikTextField label="Host" placeholder="Host" required name="host" formik={formik} />
    </ConsoleDialog>
  )
}

export default LowLatencyHostsForm
